import { COLORS } from 'colors';
const DG_FONT_SIZE = '0.775rem';

export const customTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: COLORS.GRAY_800
  }
});

export const customStyles = {
  control: (provided) => {
    return {
      ...provided,
      maxWidth: 100,
      height: '25px',
      minHeight: '25px',
      padding: '0px 5px',
      background: COLORS.TRANSLUCENT_GREY_BG,
      borderRadius: '20px',
      border: '0px',
      textAlign: 'center'
    };
  },
  valueContainer: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
    alignContent: 'center',
    height: '20px'
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: DG_FONT_SIZE,
    color: 'white'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: COLORS.GRAY_800,
    borderRadius: '5px',
    color: 'white'
  }),
  option: (provided, state) => ({
    ...provided,
    padding: 7,
    backgroundColor: state.isFocused ? COLORS.OPTION_HOVER_BG : COLORS.GRAY_800,
    fontSize: DG_FONT_SIZE
  })
};
